import { render } from "./MonglishNavbar.vue?vue&type=template&id=689ed976&scoped=true"
import script from "./MonglishNavbar.vue?vue&type=script&lang=js"
export * from "./MonglishNavbar.vue?vue&type=script&lang=js"

import "./MonglishNavbar.vue?vue&type=style&index=0&id=689ed976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689ed976"]])

export default __exports__